import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getPostsByCategory } from "@/mocks/posts";

export default function SummaryPreview() {
  const total = categories.reduce(
    (sum, cat) => sum + getPostsByCategory(cat.id).length,
    0
  );

  return (
    <section id="summary" className="w-full px-4 pb-12 md:px-6 md:pb-16">
      <div className="overflow-hidden rounded-xl bg-foreground-950">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="p-6 md:p-10 lg:col-span-6">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-900 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-200">
              <i className="ri-list-check-2"></i>
              汇总清单与归档
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              同一件事的来龙去脉
              <br className="hidden md:block" />
              都收在一张清单里
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汇总清单按主题整理，把一件事从出现到后续回应的每一次变化按顺序排好；归档中心则按日期陈列，方便你回溯「某一天都发生了什么」。
              两条路径互补，长期蹲守不会漏掉任何一条。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/summary"
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-book-2-line"></i>
                打开汇总清单
              </Link>
              <Link
                to="/archive"
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-700 px-4 py-2.5 text-sm font-semibold text-background-100 transition-colors hover:bg-secondary-900"
              >
                <i className="ri-archive-line"></i>
                进入归档中心
              </Link>
            </div>
          </div>

          <div className="border-t border-secondary-800 p-6 md:p-10 lg:col-span-6 lg:border-l lg:border-t-0">
            <div className="mb-5 flex items-center justify-between">
              <h3 className="text-sm font-semibold text-background-100">清单目录</h3>
              <span className="text-xs text-background-400">共 {total} 篇整理</span>
            </div>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/summary?cat=${cat.id}`}
                    className="group flex cursor-pointer items-center gap-3 rounded-md bg-secondary-900/60 px-4 py-3 transition-colors hover:bg-secondary-900"
                  >
                    <i className={`${cat.icon} text-lg text-accent-400`}></i>
                    <span className="flex-1 text-sm font-medium text-background-100">
                      {cat.name}
                    </span>
                    <span className="text-xs text-background-400">
                      {getPostsByCategory(cat.id).length} 篇
                    </span>
                    <i className="ri-arrow-right-s-line text-background-400 transition-transform group-hover:translate-x-0.5"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}